import script from "./MainLabledComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MainLabledComponent.vue?vue&type=script&setup=true&lang=js"

import "./MainLabledComponent.vue?vue&type=style&index=0&id=48394942&lang=css"

const __exports__ = script;

export default __exports__